/**
 * @description numbers usados a lo largo de los fomularios
 */
export const enum Numbers {
  numberN101 = -101,
  timeOut20 = 20,
  number0 = 0,
  number1 = 1,
  number2 = 2,
  number3 = 3,
  number4 = 4,
  number5 = 5,
  number6 = 6,
  number7 = 7,
  number8 = 8,
  number9 = 9,
  number10 = 10,
  number11 = 11,
  number12 = 12,
  number15 = 15,
  number16 = 16,
  number20 = 20,
  number22 = 22,
  number23 = 23,
  number24 = 24,
  number28 = 28,
  number30 = 30,
  number31 = 31,
  number34 = 34,
  number40 = 40,
  number55 = 55,
  number60 = 60,
  number67 = 67,
  number70 = 70,
  number80 = 80,
  number90 = 90,
  number97 = 97,
  number100 = 100,
  number185 = 185,
  number200 = 200,
  number350 = 350,
  number400 = 400,
  number364 = 364,
  number365 = 365,
  number512 = 512,
  number700 = 700,
  number800 = 800,
  number991 = 991,
  number1000 = 1000,
  number11000 = 11000,
  number10434 = 10434,
  number12802 = 12802,
  number12803 = 12803,
  number12804 = 12804,
  number12805 = 12805,
  number12000 = 12000,
  number17048 = 17048,
  number17049 = 17049,
  number17088 = 17088,
  number17115 = 17115,
  number17271 = 17271,
  number17093 = 17093,
  number17094 = 17094,
  number17103 = 17103,
  number17106 = 17106,
  number17118 = 17118,
  number17141 = 17141,
  number17164 = 17164,
  number17165 = 17165,
  number17166 = 17166,
  number18000 = 18000,
  number19001 = 19001,
  number19007 = 19007,
  number19002 = 19002,
  number19004 = 19004,
  number19130 = 19130,
  number30000 = 30000,
  number60000 = 60000,
  number24000 = 24000,
  number15301 = 15301,
  number15302 = 15302,
  number15303 = 15303,
  number15305 = 15305,
  number15306 = 15306,
  number15307 = 15307,
  number15308 = 15308,
  number15309 = 15309,
  number15310 = 15310
}
/**
 * @description patrones que limitan expresiones regulares
 */
export const PATTERNS = {
  number: /^[0-9]*$/,
  number1: /^[1-9]\d*$/,
  dec1: /[+][1-9]+\.[0-9]+$/,
  mobile: /^[0-9]*$/,
  email: /^([\da-z_\.-]+)@([\da-z\.-]+)\.([a-z\.]{2,6})$/,
  cp: /^([0-9]*)$/,
  passport: /^[0-9a-zA-Z]{6,9}$/,
  decimal: /[-+][0-9]+\.[0-9]+$/,
  decimalPos: /[+][0-9]+\.[0-9]+$/,
  alpha: /^[0-9a-zA-Z]+$/,
  dni: /^\d{8}[a-zA-Z]$/,
  nie: /^[XYZ][0-9]{7}[TRWAGMYFPDXBNJZSQVHLCKET]$/,
  cif1: /^[ABEH][0-9]{8}$/i,
  cif2: /^[KPQS][0-9]{7}[A-J]$/i,
  cif3: /^[CDFGJLMNRUVW][0-9]{7}[0-9A-J]$/i,
  validPassport: /^[a-zA-Z]{3}[0-9]{6}[a-zA-Z]?$/i

};
/**
 * @description caracteres validos
 */
export const VALID_CHARS = 'TRWAGMYFPDXBNJZSQVHLCKET';

/**
 * @description codigos BIC
 */
export const BIC_CODES = {
  'bic-3': 'BDEPESM1XXX',
  'bic-30': 'ESPCESMMXXX',
  'bic-31': 'ETCHES2GXXX',
  'bic-36': 'SABNESMMXXX',
  'bic-46': 'GALEES2GXXX',
  'bic-49': 'BSCHESMMXXX',
  'bic-57': 'BVADESMMXXX',
  'bic-58': 'BNPAESMMXXX',
  'bic-59': 'MADRESMMXXX',
  'bic-61': 'BMARES2MXXX',
  'bic-65': 'BARCESMMXXX',
  'bic-73': 'OPENESMMXXX',
  'bic-75': 'POPUESMMXXX',
  'bic-78': 'BAPUES22XXX',
  'bic-81': 'BSABESBBXXX',
  'bic-83': 'RENBESMMXXX',
  'bic-86': 'NORTESMMXXX',
  'bic-94': 'BVALESMMXXX',
  'bic-122': 'CITIES2XXXX',
  'bic-125': 'BAOFESM1XXX',
  'bic-128': 'BKBKESMMXXX',
  'bic-130': 'CGDIESMMXXX',
  'bic-133': 'MIKBESB1XXX',
  'bic-136': 'AREBESMMXXX',
  'bic-138': 'BKOAES22XXX',
  'bic-149': 'BNPAESMSXXX',
  'bic-167': 'GEBAESMMXXX',
  'bic-182': 'BBVAESMMXXX',
  'bic-184': 'BEDFESM1XXX',
  'bic-186': 'BFIVESBBXXX',
  'bic-188': 'ALCLESMMXXX',
  'bic-190': 'BBPIESMMXXX',
  'bic-196': 'WELAESMMXXX',
  'bic-198': 'BCOEESMMXXX',
  'bic-200': 'PRVBESB1XXX',
  'bic-211': 'PROAESMMXXX',
  'bic-216': 'POHIESMMXXX',
  'bic-219': 'BMCEESMMXXX',
  'bic-220': 'FIOFESM1XXX',
  'bic-224': 'SCFBESMMXXX',
  'bic-227': 'UNOEESM1XXX',
  'bic-229': 'POPLESMMXXX',
  'bic-231': 'DSBLESMMXXX',
  'bic-232': 'INVLESMMXXX',
  'bic-233': 'POPIESMMXXX',
  'bic-234': 'CCOCESMMXXX',
  'bic-235': 'PICHESMMXXX',
  'bic-236': 'LOYIESMMXXX',
  'bic-237': 'CSURES2CXXX',
  'bic-238': 'PSTRESMMXXX',
  'bic-239': 'EVOBESMMXXX',
  'bic-487': 'GBMNESMMXXX',
  'bic-1459': 'PRABESMMXXX',
  'bic-1460': 'CRESESMMXXX',
  'bic-1465': 'INGDESMMXXX',
  'bic-1474': 'CITIESMXXXX',
  'bic-1475': 'CCSEESM1XXX',
  'bic-1490': 'SELFESMMXXX',
  'bic-1491': 'TRIOESMMXXX',
  'bic-1524': 'UBIBESMMXXX',
  'bic-1525': 'BCDMESMMXXX',
  'bic-1534': 'KBLXESMMXXX',
  'bic-1544': 'BACAESMMXXX',
  'bic-2000': 'CECAESMMXXX',
  'bic-2013': 'CESCESBBXXX',
  'bic-2031': 'CECAESMM031',
  'bic-2038': 'CAHMESMMXXX',
  'bic-2043': 'CECAESMM043',
  'bic-2045': 'CECAESMM045',
  'bic-2048': 'CECAESMM048',
  'bic-2051': 'CECAESMM051',
  'bic-2056': 'CECAESMM056',
  'bic-2066': 'CECAESMM066',
  'bic-2080': 'CAGLESMMXXX',
  'bic-2085': 'CAZRES2ZXXX',
  'bic-2086': 'CECAESMM086',
  'bic-2095': 'BASKES2BXXX',
  'bic-2096': 'CSPAES2LXXX',
  'bic-2099': 'CECAESMM099',
  'bic-2100': 'CAIXESBBXXX',
  'bic-2103': 'UCJAES2MXXX',
  'bic-2104': 'CSSOES2SXXX',
  'bic-2105': 'CECAESMM105',
  'bic-3001': 'BCOEESMM001',
  'bic-3005': 'BCOEESMM005',
  'bic-3007': 'BCOEESMM007',
  'bic-3008': 'BCOEESMM008',
  'bic-3009': 'BCOEESMM009',
  'bic-3016': 'BCOEESMM016',
  'bic-3017': 'BCOEESMM017',
  'bic-3018': 'BCOEESMM018',
  'bic-3020': 'BCOEESMM020',
  'bic-3023': 'BCOEESMM023',
  'bic-3025': 'CDENESBBXXX',
  'bic-3029': 'CCRIES2A029',
  'bic-3035': 'CLPEES2MXXX',
  'bic-3045': 'CCRIES2A045',
  'bic-3058': 'CCRIES2AXXX',
  'bic-3059': 'BCOEESMM059',
  'bic-3060': 'BCOEESMM060',
  'bic-3063': 'BCOEESMM063',
  'bic-3067': 'BCOEESMM067',
  'bic-3070': 'BCOEESMM070',
  'bic-3076': 'BCOEESMM076',
  'bic-3080': 'BCOEESMM080',
  'bic-3081': 'BCOEESMM081',
  'bic-3084': 'CVRVES2BXXX',
  'bic-3085': 'BCOEESMM085',
  'bic-3089': 'BCOEESMM089',
  'bic-3095': 'CCRIES2A095',
  'bic-3096': 'BCOEESMM096',
  'bic-3098': 'BCOEESMM098',
  'bic-3102': 'BCOEESMM102',
  'bic-3104': 'BCOEESMM104',
  'bic-3105': 'CCRIES2A105',
  'bic-3110': 'BCOEESMM110',
  'bic-3111': 'BCOEESMM111',
  'bic-3112': 'CCRIES2A112',
  'bic-3113': 'BCOEESMM113',
  'bic-3115': 'BCOEESMM115',
  'bic-3116': 'BCOEESMM116',
  'bic-3117': 'BCOEESMM117',
  'bic-3118': 'CCRIES2A118',
  'bic-3119': 'CCRIES2A119',
  'bic-3121': 'CCRIES2A121',
  'bic-3123': 'CCRIES2A123',
  'bic-3127': 'BCOEESMM127',
  'bic-3130': 'BCOEESMM130',
  'bic-3134': 'BCOEESMM134',
  'bic-3135': 'CCRIES2A135',
  'bic-3138': 'BCOEESMM138',
  'bic-3140': 'BCOEESMM140',
  'bic-3144': 'BCOEESMM144',
  'bic-3146': 'CCCVESM1XXX',
  'bic-3150': 'BCOEESMM150',
  'bic-3152': 'CCRIES2A152',
  'bic-3157': 'CCRIES2A157',
  'bic-3159': 'BCOEESMM159',
  'bic-3160': 'CCRIES2A160',
  'bic-3162': 'BCOEESMM162',
  'bic-3165': 'CCRIES2A165',
  'bic-3166': 'BCOEESMM166',
  'bic-3174': 'BCOEESMM174',
  'bic-3179': 'CCRIES2A179',
  'bic-3183': 'CASDESBBXXX',
  'bic-3186': 'CCRIES2A186',
  'bic-3187': 'BCOEESMM187',
  'bic-3190': 'BCOEESMM190',
  'bic-3191': 'BCOEESMM191',
  'bic-9000': 'ESPBESMMXXX'
};
/**
 * @description cadenas de texto en ambos idiomas para el componente del calendario
 */
export const CALENDAR_LANGUAJE_ES = {
  firstDayOfWeek: 1,
  dayNames: ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sabado'],
  dayNamesShort: ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sab'],
  dayNamesMin: ['Do', 'Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sa'],
  monthNames: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto',
    'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
  monthNamesShort: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul',
    'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
  today: 'Today',
  clear: 'Clear',
  weekHeader: 'Wk'
};
/**
 * @description constantes que se usan a lo largo del formulario
 */
export const DOCUMENTS_CONST = {
  idProveedor: 1,
  idPortal: 1,
  productGeneral: 1,
  productIPId: Numbers.number8,
  productNota: Numbers.number9,
  generalName: 'condicionado_general',
  ipidName: 'document_ipid',
  notaName: 'document_nota'
};

/**
 * @description tipos de cobertura que disponen los seguros
 */
export const COVERAGE_TYPES = {
  'form1.duration-temporal': 'Temporal',
  'form3.duration-temporal': 'Temporal',
  Temporal: 'Temporal',
  Temporary: 'Temporal',
  'form1.duration-anual': 'Anual',
  'form3.duration-anual': 'Anual',
  Anual: 'Anual',
  'form1.duration-long': 'Anual_+90',
  'form3.duration-long': 'Anual_+90',
  'Larga Estancia': 'Anual_+90',
  'Long stay': 'Anual_+90'
};

/**
 * @description duración de los seguros
 */
export const DURATION_INPUTS = [
  'form1.duration-temporal',
  'form1.duration-anual',
  'form1.duration-long',
  'form3.duration-temporal',
  'form3.duration-anual',
  'form3.duration-long'];
/**
 * @description tipos de viajeros
 */
export const TRAVELERS_TYPE = {
  firstOpt: undefined,
  firstOptBaseAnual: 'anual',
  firstOptBaseAnualTemp: 'temporal',
  firstOptBase90: '90'
};
/**
 * @description elementos que validar
 */
export const ELEMENTS_TO_VALIDATE = ['numberOfInsured', 'guaranteeLimitOfMedicalExpenses', 'countryOrigin', 'countryDestiny', 'dateStart', 'dateEnd'];

/**
 * @description constantes que se usan a lo largo del formulario
 */
export const commondSelectOptionsList = [
  { name: '0', id: Numbers.number0 },
  { name: '1', id: Numbers.number1 },
  { name: '2', id: Numbers.number2 },
  { name: '3', id: Numbers.number3 }
];
/**
 * @description limites presupuestados
 */
export const commondRowLimits = [
  { name: '0 €', id: -1 },
  { name: '20.000 €', id: Numbers.number0 },
  { name: '30.000 €', id: Numbers.number1 }
];
